/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Bank(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M248.00244,208a8.00039,8.00039,0,0,1-8,8h-224a8,8,0,0,1,0-16h224A8.00039,8.00039,0,0,1,248.00244,208ZM16.30518,98.17871a7.99868,7.99868,0,0,1,3.50488-8.99219l104-64a7.9998,7.9998,0,0,1,8.38476,0l104,64A8.0001,8.0001,0,0,1,232.00244,104h-24v64h16a8,8,0,0,1,0,16h-192a8,8,0,0,1,0-16h16V104h-24A7.999,7.999,0,0,1,16.30518,98.17871ZM144.00244,160a8,8,0,0,0,16,0V112a8,8,0,1,0-16,0Zm-48,0a8,8,0,0,0,16,0V112a8,8,0,0,0-16,0Z" />
    </Svg>
  );
}

export default Bank;
